import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import jQueryVisible from 'jquery-visible';

function queryPost() {
  const $container = $('.infinite-scroll');
  const $pages = $('.infinite-scroll__page');
  $pages.each(function () {
    const $this = $(this);
    if ($this.visible(true) && +$this.attr('data-loaded') === 0) {
      $this.attr('data-loaded', 1);
      const nextPage = $this.attr('data-page');
      $.ajax({
        type: 'POST',
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: { action: 'media_get_posts', paged: nextPage },
        dataType: 'html',
        beforeSend() {
          $this.find('.infinite-scroll__loader').show();
        },
        complete() {
          $this.find('.infinite-scroll__loader').hide();
        },
        success(data) {
          $container.append(data);
          $('.infinite-scroll__loader').hide();
        },
        error(xhr, status, thrown) {
          console.log(thrown);
          console.log(status);
          console.log(xhr);
        },
      });
    }
  });
}

$(document).ready(() => {
  if ($('.infinite-scroll__page')[0]) {
    queryPost();
  }
});

$(window).on('scroll', () => {
  if ($('.infinite-scroll__page')[0]) {
    queryPost();
  }
});
